import React from 'react';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  tone?: 'green' | 'white' | 'black';
  underline?: boolean;
  /** `compact` for long titles that would wrap at the display size. */
  size?: 'display' | 'compact';
  /** Grey rules either side of the title when there is no underline. */
  rules?: boolean;
}

const toneClass: Record<NonNullable<SectionHeadingProps['tone']>, string> = {
  green: 'text-[#78BE20]',
  white: 'text-white',
  black: 'text-black',
};

const SectionHeading: React.FC<SectionHeadingProps> = ({ title, subtitle, tone = 'green', underline = false, size = 'display', rules = true }) => (
  <div className="text-center">
    <div className="flex items-center justify-center gap-6">
      {!underline && rules && <span className="hidden sm:block h-px w-24 md:w-36 bg-gradient-to-r from-transparent to-black/25" />}
      <h2
        className={`font-montserrat font-extrabold tracking-[-0.05em] leading-none ${size === 'compact' ? 'text-[clamp(30px,4vw,54px)]' : 'text-[clamp(40px,6vw,80px)]'} ${toneClass[tone]}`}
      >
        {title}
      </h2>
      {!underline && rules && <span className="hidden sm:block h-px w-24 md:w-36 bg-gradient-to-l from-transparent to-black/25" />}
    </div>
    {/* The client asked for the green scribble in place of a plain green bar (2026-09-26). */}
    {underline && (
      <img src="/home/scribble-green.png" alt="" aria-hidden="true" className="mx-auto mt-5 w-32 md:w-44 h-auto" loading="lazy" />
    )}
    {subtitle && (
      <p className={`font-poppins mt-6 text-sm md:text-base ${tone === 'white' ? 'text-white' : 'text-black'}`}>
        {subtitle}
      </p>
    )}
  </div>
);

export default SectionHeading;
